
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import { environment } from './../../../../../environments/environment';
import { ServiceBase } from './../../../../shared/service-base/ServiceBase';

@Injectable()
export class TipoOsService
extends ServiceBase {
  private baseUrlService: string;
  constructor (
    http: HttpClient,
    router: Router
  ) {
    super(http, router);
    this.baseUrlService = environment.URL_API
  }

  url = '';

  protected getURL(): string {
    return this.url;
  }

  private definirURLTipoOs() {
    this.url = `${this.baseUrlService}/tipo_os`;
  }

  public getFiltroTipoOs(): Promise<any> {
    this.definirURLTipoOs();
    return this.get([]);
  }

  private definirURLFiltroMarca() {
    this.url = `${this.baseUrlService}/dash_filtro_marcas`;
  }

  public getFiltroMarcas(): Promise<any> {
    this.definirURLFiltroMarca();
    return this.get([]);
  }
}
